import { Logger } from '../utils/logger';
import { Company } from './Company';
import { CourseSection } from './CourseSection';
import { CoursewareIsbn } from './CoursewareIsbn';
import { Enrollment } from './Enrollment';
import { Item } from './Item';
import { Person } from './Person';
import { translateProductForTransport, translateProductFromTransport } from './Product';

export interface AccessCode extends Item {
  code: string;

  schoolId: number;
  school?: Company;

  termId: number;
  term?: Company;

  personId?: number;
  person?: Person;

  enrollmentId?: number;
  enrollment?: Enrollment;

  courseSectionId: number;
  courseSection?: CourseSection;

  distributorId?: number;
  distributor?: Company;

  checkoutRefundAt?: Date;
  checkoutRefundId?: string;

  accessCodeOrderId?: number;

  isUsed: boolean;
  coursewareIsbnId?: number;
  coursewareIsbn?: CoursewareIsbn;
  CoursewareIsbn?: CoursewareIsbn;
  product?: any;
  courseProduct?: any;
}

export const translateAccessCodeFromTransport = (attributes: any): any => {
  Logger.log(`translateAccessCodeFromTransport: ${JSON.stringify(attributes)}`);

  const response = { ...attributes };

  if (attributes.product) {
    response.product = translateProductFromTransport(attributes.product);
  }

  if (attributes.courseProduct) {
    response.courseProduct = translateProductFromTransport(attributes.courseProduct);
  }

  return response;
};

export const translateAccessCodeForTransport = (attributes: any): any => {
  Logger.log(`translateAccessCodeForTransport: in: ${JSON.stringify(attributes)}`);

  if (attributes.courseProduct) {
    attributes.courseProduct = translateProductForTransport(attributes.courseProduct);
  }

  if (attributes.product) {
    attributes.product = translateProductForTransport(attributes.product);
  }

  Logger.log(`translateAccessCodeForTransport: out: ${JSON.stringify(attributes)}`);

  return attributes;
};
